module.exports = __webpack_public_path__ + "media/images/ditjennak-logo-f638b48fafa2847b48b72920a1931294.png";